import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Michael Smith', 
        title: 'Homeowner, Greenfield Estate',
        content: 'The CCTV installation service was exceptional. The team ensured every corner of our property is under surveillance, and the image clarity is outstanding. Highly recommend their security solutions!'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Emily Davis', 
        title: 'Manager, TechWorks Inc.',
        content: 'We feel much safer with their advanced access control system. The setup was seamless, incredibly efficient, and the customer support is always responsive. A fantastic team to work with!'
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'James Wilson', 
        title: "Owner, Wilson's Supermarket",
        content: 'Their security alarm systems are absolutely top-notch and reliable. We’ve had no issues since installation, and the team was professional, highly efficient, and thorough. Great value for money!'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Sarah Johnson', 
        title: 'CEO, Brightway Logistics',
        content: 'Our business has never been more secure. The video surveillance system is state-of-the-art, and their team provided excellent training on how to use it. Highly recommended!'
    },
];

export default testimonials;